<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="form-group" [formGroup]="parentFormGroup">
  <label *ngIf="!hideLabel">{{ 'BANK_ACCOUNT_SELECT.BANK_ACCOUNT' | translate }}</label>
  <ng-select
    (change)="onChange($event)"
    [items]="data"
    bindLabel="displayName"
    bindValue="id"
    appendTo="body"
    [formControlName]="'bank_account_id'"
  >
    <ng-template ng-typetosearch-tmp>
      <div class="ng-option disabled">
        {{ 'START_TYPING' | translate }}
      </div>
    </ng-template>

    <ng-template ng-label-tmp let-item="item">
      {{ item.displayName }}
    </ng-template>

    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
      {{ item.displayName }}
    </ng-template>

    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
      <div class="ng-option disabled">
        <div>{{ 'BANK_ACCOUNT_SELECT.NO_BANK_BANK_ACCOUNT_FOUND_MSG' | translate }}</div>
      </div>
    </ng-template>
  </ng-select>
</div>
